<template>
  <div class="modal-body-content">
    <div class="modal-body-list-box">
      <div class="search-box-in-title">
        <h2>POI {{ $t('list') }}</h2>
        <div>
          <input v-model="search" :placeholder="$t('insert_search_query')" />
          <button type="button" @click.stop="addCustomMarker()" class="action-button">{{ $t('create_new') }}</button>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th :class="getIsMobile() ? 'w20p' : 'w10p'">
              {{ $t('image') }}
            </th>
            <th :class="getIsMobile() ? 'w80p' : 'w30p'" @click="toggleSort('poi', 'title')">
              POI {{ $t('name') }}
              <span v-if="sortStates.poi.find(col => col.id === 'title').order">
                <img v-if="sortStates.poi.find(col => col.id === 'title').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w30p" @click="toggleSort('poi', 'description')">
              POI {{ $t('description') }}
              <span v-if="sortStates.poi.find(col => col.id === 'description').order">
                <img v-if="sortStates.poi.find(col => col.id === 'description').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w20p" @click="toggleSort('poi', 'created_at')">
              {{ $t('creation_date') }}
              <span v-if="sortStates.poi.find(col => col.id === 'created_at').order">
                <img v-if="sortStates.poi.find(col => col.id === 'created_at').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w10p" style="cursor: not-allowed;">{{ $t('manage') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="poi in paginatedData" :key="poi.marker_id" :style="poi.is_deleted ? { background: '#EBEBEB' } : {}">
            <td :class="getIsMobile() ? 'w20p' : 'w10p'">
              <img :src="showMarkerImage(poi.marker_image)" style="height: 35px; margin: 0; padding: 0; vertical-align: middle;"/>
            </td>
            <td :title="poi.title" :class="getIsMobile() ? 'w80p' : 'w30p'" @click.stop="editPOI(poi)" style="text-align: left; padding-left: 20px;">
              {{ poi.title }}
            </td>
            <td v-show="!getIsMobile()" :title="poi.description" class="w30p" @click.stop="editPOI(poi)" style="text-align: left; padding-left: 20px;">
              {{ poi.description }}
            </td>
            <td v-show="!getIsMobile()" :title="poi.created_at" class="w20p" @click.stop="editPOI(poi)" style="text-align: center; padding: 0;">
              {{ ConvertDateTimeString(new Date(poi.created_at), "YYYY-MM-DD HH:MM:SS") }}
            </td>
            <td v-show="!getIsMobile()" class="w10p" v-if="!poi.is_deleted">
              <img @click.stop="editPOI(poi)" src="@/assets/images/edit.svg" :title="$t('modify')"/>
              <img @click.stop="deletePOI(poi.marker_id)" src="@/assets/images/delete.svg" :title="$t('delete')"/>
            </td>
            <td v-show="!getIsMobile()" class="w10p" v-else>
              <img @click.stop="restorePOI(poi.marker_id)" src="@/assets/images/restore.svg" :title="$t('restore')"/>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 페이지네이션 -->
      <div class="pagination-control">
        <div>
          <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
          <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
        </div>
        <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }" :style="currentPage === page ? {cursor: 'default'} : {}">{{ page }}</span>
        <div>
          <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
        </div>
      </div>
    </div>

    <POIModalSimple v-if="isPOIModalSimpleOpen2" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, nextTick, watch } from 'vue';
import { ConvertDateTimeString, getIsMobile } from '@/utils/GlobalUtility';
import { loadingStore } from '@/utils/LoadingStore';
import { sortedPOIList, sortStates, toggleSort } from '@/utils/SortUtility';
import { showSmallModal } from '@/utils/ModalUtility';
import { imageUrl } from '@/utils/ServerConnect';
import { Get_Image_Now_OR_Default } from '@/utils/Setting';
import POIModalSimple from './POIModalSimple.vue';
import { addCustomMarker, isPOIModalSimpleOpen2, selectedCustomMarker } from '@/utils/MapSetting';
import { deletePOI, fetchPOIData, restorePOI } from '@/utils/POIUtility';

onMounted(() => {
  nextTick(async () => {
    showSmallModal.value = true;
  
    await fetchPOIData();

    showSmallModal.value = false;
    loadingStore.hideLoading();
  })
});

const showMarkerImage = (img) => {
  return img ? imageUrl() + img : Get_Image_Now_OR_Default('marker_now_icon');
};

const editPOI = (poi) => {
  selectedCustomMarker.value = poi;
  isPOIModalSimpleOpen2.value = true;
}

const currentPage = ref(1);
const itemsPerPage = ref(10);
const showOncePage = computed(() => { return (getIsMobile() ? 5 : 10) });
// 페이지네이션된 데이터 계산
const totalPages = computed(() =>
  Math.ceil(filteredList.value.length / itemsPerPage.value)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return filteredList.value.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};

const search = ref("");
const filteredList = computed(() => {
  const query = search.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  return sortedPOIList.value.filter(poi =>
    String(poi.title).toLowerCase().includes(query) // 이름으로 검색
    || String(poi.description).toLowerCase().includes(query) // 이름으로 검색
  );
});

// 현재 보고있는 페이지를 전체 페이지수에 맞춰 자동으로 바꿔줌
watch(
  () => filteredList.value.length,
  () => {
    const newTotalPages = Math.ceil(filteredList.value.length / itemsPerPage.value);
    if (currentPage.value > newTotalPages) {
      currentPage.value = newTotalPages || 1; // 0일 때도 대비
    }
  }
);
</script>